import moment from 'moment';

// Given a time label (01:12:30), turn it into seconds
export function formattedLabelToSeconds(label) {
  var parts = (label || '').split(':');
  if (parts.length == 1) {
    return parseInt(parts[0], 10);
  } else if (parts.length == 2) {
    return 60 * parseInt(parts[0], 10) + parseInt(parts[1], 10);
  } else if (parts.length == 3) {
    return 3600 * parseInt(parts[0], 10) + 60 * parseInt(parts[1], 10) + parseInt(parts[2], 10);
  } else {
    return undefined;
  }
}

// Generate a nice time label from the given amount of seconds (H:mm:ss)
export function secondsToFormattedLabel(seconds, showSeconds = true, showHoursIfZero = true) {
  let ss = _.padLeft(parseInt(Math.round(seconds % 60)).toString(), 2, '0');
  if (ss == '60') {
    ss = '59'; //rounding above, but 59.75 should not be displayed as 60.
  }
  let mins = seconds / 60 || 0;
  let mm = _.padLeft(parseInt(Math.floor(mins % 60)).toString(), 2, '0');
  let h = parseInt(Math.floor(mins / 60)).toString();
  let hStr = h > 0 || showHoursIfZero ? `${h}:` : '';
  if (showSeconds) {
    return `${hStr}${mm}:${ss}`;
  } else {
    return `${hStr}${mm}`;
  }
}

// Generate a nice time label from the given amount of seconds in the format XdXhXmXs
export function secondsToFormattedLabel2(s) {
  let totalSeconds = parseInt(Math.round(s || 0));
  const secondsPart = totalSeconds % 60;
  const totalMinutes = (totalSeconds - secondsPart) / 60;
  const minutesPart = totalMinutes % 60;
  const totalHours = (totalMinutes - minutesPart) / 60;
  const hoursPart = totalHours % 24;
  const daysPart = (totalHours - hoursPart) / 24;

  let secondsString = '';
  let minutesString = '';
  let hoursString = '';
  let daysString = '';
  if (daysPart == 0) {
    if (hoursPart == 0) {
      if (minutesPart == 0) {
        secondsString = `${secondsPart.toString()}s`;
      } else {
        minutesString = `${minutesPart.toString()}m`;
        secondsString = `${secondsPart.toString()}s`;
      }
    } else {
      hoursString = `${hoursPart.toString()}h`;
      minutesString = `${minutesPart.toString()}m`;
      secondsString = `${secondsPart.toString()}s`;
    }
  } else {
    daysString = `${daysPart.toString()}d`;
    hoursString = `${hoursPart.toString()}h`;
    minutesString = `${minutesPart.toString()}m`;
    secondsString = `${secondsPart.toString()}s`;
  }

  return `${daysString}${hoursString}${minutesString}${secondsString}`;
}

// Generate a nice duration label from the difference between the two dates
export function differenceFormattedAsDurationLabel(start, end, showSeconds = true) {
  end = !end || moment.isMoment(end) ? end : moment(end);
  if (!end || end.year() >= 9999) {
    return ''; // XXX: Some broadcasts (specifically, simulated live) do not have an end time
  }
  let durationSecs = moment(end).diff(moment(start)) / 1000;
  if (durationSecs < 0) {
    return ''; // XXX: some broadcasts have a stops_at before starts_at
  }
  return secondsToFormattedLabel(durationSecs, showSeconds);
}

// Use the date part of the given date object and the time part of the given time object
// and return a ISO 8601 formatted date/time in UTC.
export function toDateTimeString(date, time) {
  let dateStr = moment(date).format('YYYY-MM-DD');
  let timeStr = moment(time).format('HH:mm:00');
  let combined = moment(`${dateStr} ${timeStr}`);
  return combined.toISOString(true);
}

// Given a start date and start/end time objects, make sure they all
// line up with business rules around crossing midnight. Return a
// valid starts_at and stops_at string.
export function adjustBroadcastDatesForCrossingMidnight(
  startDate,
  startTime,
  endTime,
  maxBroadcastDurationHours
) {
  let endDate = startDate;
  if (!endTime) {
    endTime = moment(startTime).add(maxBroadcastDurationHours, 'hours').toDate();
  }
  if (moment(endTime).format('HH:mm') <= moment(startTime).format('HH:mm')) {
    endDate = moment(endDate).add(1, 'days');
  }
  return {
    startDate: startDate,
    startTime: startTime,
    endDate: endDate,
    endTime: endTime,
    starts_at: toDateTimeString(startDate, startTime),
    stops_at: toDateTimeString(endDate, endTime),
  };
}

// Look for the nicely formatted version (localized) of the start date and
// replace with the string "[date]"
export function unreplaceDateTokens(text, date) {
  const now = moment(date).local();

  const regExpWithoutSpace = new RegExp(now.format('LL'), 'g');

  const month = now.format('MMMM');
  const dayOfMonth = now.format('D');
  const year = now.format('YYYY');
  const extraSpace = dayOfMonth.length < 2 ? ' ' : '';
  const regExpWithSpace = new RegExp(`${month} ${extraSpace}${dayOfMonth}, ${year}`, 'g');

  return text.replace(regExpWithoutSpace, '[date]').replace(regExpWithSpace, '[date]');
}

export function getDatesForClonedBroadcast(broadcast, now) {
  var start = moment(broadcast.starts_at).clone();
  var stop = moment(broadcast.stops_at).clone();
  var duration = stop.diff(start, 'minutes');

  if (broadcast.timeframe == 'future') {
    // If copying a future broadcast, keep broadcast.starts_at/stops_at from clone
    return {
      starts_at: broadcast.starts_at,
      stops_at: broadcast.stops_at,
    };
  } else {
    // Otherwise, try to keep same start/stop time but advance the date to today
    // and always keep the same duration as the original broadcast.
    // If the start time has already elapsed for the day, bump the start to now.
    start.set({
      year: now.get('year'),
      month: now.get('month'),
      date: now.get('date'),
    });
    if (start < now) {
      start = now;
    }
    stop = start.clone().add(duration, 'minutes');
    return {
      starts_at: start.format(),
      stops_at: stop.format(),
    };
  }
}



// WEBPACK FOOTER //
// ./app/utils/date.js